import { initContract } from '@ts-rest/core';
const c = initContract();
export const router = c.router;
export const query = c.query;
export const mutation = c.mutation;
export const otherResponse = c.otherResponse;
export const type = c.type;
export const noBody = c.noBody;
